module.exports = __webpack_public_path__ + "static/media/anular.8e4050dd.jpeg";